module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DREAMS and VISIONS")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('span', [_c('i', [_vm._v("To Jesus~ ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("You are the King of the Universe and my "), _c('br'), _vm._v("savior. How amazing You are! We live in days"), _c('br'), _vm._v("of accelerated global transformation and social"), _c('br'), _vm._v("unrest, yet You remain the rock of our salvation"), _c('br'), _vm._v("and the anchor of our hope.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc45",
    attrs: {
      "id": "p0011-03-3"
    }
  }, [_c('span', [_c('i', [_vm._v("I love you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-03-4"
    }
  }, [_c('span', [_c('i', [_vm._v("“In this world you will have trouble. But take "), _c('br'), _vm._v("heart! I have overcome the world.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc456",
    attrs: {
      "id": "p0011-04-6"
    }
  }, [_c('span', [_c('i', [_vm._v("John 16:33 ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbc6f20e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 72
// module chunks = 0